/**
 * Situation d'un utilisateur : il peut être seul ou en couple (HH, HF, FF...)
 */
export class MembreSituation {
    /**
     * Constructeur de l'objet MembreSituation
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d;
        if (row) {
            this.idMembreSituation = (_a = row.idMembreSituation) !== null && _a !== void 0 ? _a : null;
            this.couple = !!row.couple;
            this.libelle = (_b = row.libelle) !== null && _b !== void 0 ? _b : null;
            this.actif = (_c = row.actif) !== null && _c !== void 0 ? _c : null;
            this.ordre = (_d = row.ordre) !== null && _d !== void 0 ? _d : null;
        }
    }
    /**
     * Récupération d'une situation en BDD
     * @return MembreSituation
     */
    static find( /* id: number */) {
        // TODO
    }
    /**
     * Sauvegarde en BDD
     * @return void
     */
    save() {
        // TODO
    }
    /**
     * Retire l'objet de l'affichage en mettant son statut actif à 2.
     * @return void
     */
    delete() {
        // TODO
    }
    /**
     * Utilisée pour renvoyer les informations au front.
     */
    toClient() {
        return {
            couple: this.couple,
            libelle: this.libelle,
            actif: this.actif,
            ordre: this.ordre,
            idMembreSituation: this.idMembreSituation,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlU2l0dWF0aW9uLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiTWVtYnJlU2l0dWF0aW9uLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGVBQWU7SUErQjNCOzs7T0FHRztJQUNILFlBQW1CLEdBQThCOztRQUNoRCxJQUFJLEdBQUcsRUFBRTtZQUNSLElBQUksQ0FBQyxpQkFBaUIsR0FBRyxNQUFBLEdBQUcsQ0FBQyxpQkFBaUIsbUNBQUksSUFBSSxDQUFDO1lBQ3ZELElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUM7WUFDM0IsSUFBSSxDQUFDLE9BQU8sR0FBRyxNQUFBLEdBQUcsQ0FBQyxPQUFPLG1DQUFJLElBQUksQ0FBQztZQUNuQyxJQUFJLENBQUMsS0FBSyxHQUFHLE1BQUEsR0FBRyxDQUFDLEtBQUssbUNBQUksSUFBSSxDQUFDO1lBQy9CLElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBQSxHQUFHLENBQUMsS0FBSyxtQ0FBSSxJQUFJLENBQUM7U0FDL0I7SUFDRixDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksTUFBTSxDQUFDLElBQUksRUFBQyxnQkFBZ0I7UUFDbEMsT0FBTztJQUNSLENBQUM7SUFFRDs7O09BR0c7SUFFSSxJQUFJO1FBQ1YsT0FBTztJQUNSLENBQUM7SUFFRDs7O09BR0c7SUFFSSxNQUFNO1FBQ1osT0FBTztJQUNSLENBQUM7SUFFRDs7T0FFRztJQUNJLFFBQVE7UUFDZCxPQUFPO1lBQ04sTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNO1lBQ25CLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTztZQUNyQixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLO1lBQ2pCLGlCQUFpQixFQUFFLElBQUksQ0FBQyxpQkFBaUI7U0FDekMsQ0FBQztJQUNILENBQUM7Q0FDRCJ9